import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { httpRequestTimeoutMetadata } from '../consts/metadata-consts';

export const odataResourceMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.odata.datasetType,
    displayName: stringResources.ODataResource_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.odata.linkedServiceType],
    isSource: true,
    isSink: false,
    notSupportTypeConversion: true,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-OData'
    },
    tableNameDisplay: stringResources.PathLabel,
    tableNamePlural: stringResources.PathsLabel,
    isFirstClass: true,
    isTableNameRequired: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['GenericProtocol'],
    tableAlias: 'path',
    copySourceControls: [httpRequestTimeoutMetadata]
};
